import React, { Fragment } from 'react'

import { SpanWithData } from '../'

import { showAsCurrency } from '../../utils'

export const AccountData = ({ creditReportSupplier, balance, instalment, paymentFreqDesc, paymentHistory }) => (
  <Fragment>
    <td title={`${creditReportSupplier.classification} | ${creditReportSupplier.secured ? 'Secured' : 'Not secured'} | ${creditReportSupplier.instalmentIsBalance ? 'Instalment is balance' : 'Instalment is not balance'}`}>
      {creditReportSupplier && creditReportSupplier.name}
    </td>
    <td>{showAsCurrency('R', balance)}</td>
    <td>{showAsCurrency('R', instalment)}</td>
    <td><SpanWithData forField='CreditReportAccountPaymentFreqDesc' searchKey={paymentFreqDesc} /></td>
    <td title={paymentHistory}>
      {paymentHistory ? paymentHistory.slice(-5) : ''}
    </td>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/components/credit-application-credit-report/AccountData.js